var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DatePicker',{attrs:{"value":_vm.value,"multiple":"","format":"DD-MM-YYYY","placeholder":"Seleziona le date","disabled-date":_vm.combinedDisabledDate},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }